export enum NavCategory {
  HOME = 'home',
  CATEGORIES = 'categories',
  BRANDS = 'brands',
  SEARCH = 'search',
}
